import React, { Component } from 'react';
import { SiteWrapper } from "../common";
import { Page, Card, Button, Alert } from "tabler-react";
import ReactTable from "react-table";
import { findUsers } from '../actions';
import { NavLink } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Auth from '../auth/auth';

const auth = new Auth({});


class UserPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      alert: {
        display: false,
        type: '',
        icon: '',
        message: ''
      }
    };

    this.fetchUsers = this.fetchUsers.bind(this);

  }

  componentDidMount() {
    let alert = localStorage.getItem('deleteUser');
    if (alert) {
      alert = JSON.parse(alert);
      this.setState({ alert });
      localStorage.removeItem('deleteUser');
    }
  }

  fetchUsers(state, instance) {
    this.setState({ loading: true });

    const callback =  () => { this.setState({ loading: false }) }

    // set the order and ascDesc
    let order = 'createdOn', ascDesc = 'desc';

    if (state.sorted.length > 0) {
       const lastIndex = state.sorted.length - 1;
       order = state.sorted[lastIndex].id;
       ascDesc = state.sorted[lastIndex].desc ? 'desc' : 'asc';
    }

    // set the filterable
    const { filtered } = state;
    const userName = filtered.find(f => f.id === 'userName');

    this.props.findUsers(state.page + 1, state.pageSize, order, ascDesc, userName?userName.value:'', callback, callback);
  }

  renderRoles(role) {
    return (
      <span key={role.id} className="mr-2">{role.type}/{role.name}</span>
    );
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display &&
          <Alert type={this.state.alert.type} icon={this.state.alert.icon} isDismissible>
            {this.state.alert.message}
          </Alert>
        }
      </div>
    );
  }

  render ()  {
    const { users } = this.props;
    const { loading } = this.state;
    const { pagination } = users;
    const { totalPages } = pagination ? pagination : { totalPages: 1 };
    const columns = [
      {
        Header: 'User Name',
        accessor: 'userName'
      },
      {
        Header: 'Email',
        filterable: false,
        accessor: 'email'
      },
      {
        Header: 'Roles',
        filterable: false,
        accessor: 'roles',
        Cell: row => row.value.map(v => this.renderRoles(v))
      },
      {
        Header: 'Actions',
        sortable: false,
        filterable: false,
        accessor: 'id',
        Cell: row => (
          <NavLink to={`/users/${row.value}`}>
            <Button size="sm" color="primary" icon="edit-2">Edit</Button>
          </NavLink>
        )
      }
    ];

    return (
        <SiteWrapper>
            <Page.Content>
              {this.renderAlert()}
              <Card>
                <Card.Header>
                  <Card.Title>Users</Card.Title>
                  {auth.hasAccess('user', 'read') &&
                  <Card.Options>
                    <NavLink to="/users/new">
                      <Button color="success" icon="plus">New User</Button>
                    </NavLink>
                  </Card.Options>
                  }
                </Card.Header>
                <Card.Body>
                  <ReactTable
                    data={users.items}
                    columns={columns}
                    loading={loading}
                    pages={totalPages}
                    showPaginationTop
                    showPaginationBottom
                    filterable
                    manual
                    className="-striped -highlight"
                    onFetchData={this.fetchUsers}
                  />
                </Card.Body>
              </Card>
            </Page.Content>
        </SiteWrapper>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({  findUsers }, dispatch)
}

function mapStateToProps({ users }) {
  return { users };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPage)



// WEBPACK FOOTER //
// ./src/user/user.react.js